import React, { useEffect, useContext, useState, useRef } from 'react';
import { usePaymentOptions } from 'common/hooks/usePaymentOptions';
import Skeleton from 'react-loading-skeleton';
import {
    FieldProps,
    EditableField,
} from 'features/account-settings/components/SettingsTab/PersonalSettings/utils';
import { EditableFieldsContext } from '../../context';
import { useAddresses } from 'common/hooks/useAddresses';
import { LoadingOverlay } from 'components/loading-overlay/LoadingOverlay';

import { BankField as BankFieldDisplay } from './BankFieldDisplay';
import { BankEditFieldComponent } from './BankFieldEdit';
import { PaymentOptionsView } from './context';

interface BankFieldProps extends FieldProps {}

const BankEditableFields = () => {
    const { fieldToEdit } = useContext(EditableFieldsContext);

    return (
        <div>
            <EditableField<BankFieldProps>
                id="bank-account"
                className="mb-8"
                editMode={Boolean(fieldToEdit)}
                isEditing={fieldToEdit === 'bank-account'}
                FieldDisplayComponent={BankFieldDisplay}
                FieldEditComponent={BankEditFieldComponent}
            />
        </div>
    );
};

export const AchManagementSection = () => {
    const { loadPaymentOptionsData: loadPaymentOptions } = usePaymentOptions();
    const loader = useRef<LoadingOverlay>(null);

    const { addresses, refreshAddresses } = useAddresses();
    const [dataLoading, setDataLoadingTo] = useState<boolean>(true);

    useEffect(() => {
        (async () => {
            await refreshAddresses();
            setDataLoadingTo(false);
        })();
    }, [refreshAddresses]);

    if (dataLoading) {
        return <Skeleton className="h-40" />;
    }

    return (
        <div className="payment_options_bank_account_section">
            <PaymentOptionsView
                loader={loader}
                refreshAddresses={refreshAddresses}
                addresses={addresses ?? []}
                reloadAchInfo={loadPaymentOptions}
            >
                <BankEditableFields />
            </PaymentOptionsView>
            <LoadingOverlay ref={loader} />
        </div>
    );
};
